module.exports = __webpack_public_path__ + "img/green_023.6dd5756a.png";